import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { Education } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import { formatSpacedNumber } from '../../../../../../utils/format';
import { radioOptions } from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import { DebtFormGroupData } from '../../../FormData.no.types';
import styles from '../../../loan.module.scss';
import {
  debtCarOutstandingAmountFieldOption,
  debtStudentOutstandingAmountFieldOption,
} from './config';

export const DebtFormGroup = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const { axoFormData } = useAxoFormContext();

  const askStudentDebt =
    axoFormData['LoanApplication/Education'] ===
    Education.EducationHigherEducation;

  const askCarDebt = watch('Frontend/HasCarDebt') === 'Yes';

  return (
    <>
      {askStudentDebt && (
        <Grid columns={gridColumns}>
          <NumberFieldUI<DebtFormGroupData>
            name="Debt/Student/OutstandingAmount"
            label={t('Debt.Student.OutstandingAmount.label')}
            data-testid="debt-student-outstanding-amount-input"
            format={formatSpacedNumber}
            suffix={t('suffix.currency')}
            {...debtStudentOutstandingAmountFieldOption}
          />
        </Grid>
      )}

      <div className={styles.inputGroup} data-grey={true}>
        <Grid columns={gridColumns}>
          <RadioFieldUI<DebtFormGroupData>
            name="Frontend/HasCarDebt"
            label={t('Debt.Car.question')}
            data-testid="has-car-debt-radio"
            radioStyle="both"
            options={radioOptions}
          />

          {askCarDebt && (
            <NumberFieldUI<DebtFormGroupData>
              name="Debt/CarMCBoat/OutstandingAmount"
              label={t('Debt.Car.OutstandingAmount.label')}
              data-testid="debt-car-outstanding-amount-input"
              format={formatSpacedNumber}
              suffix={t('suffix.currency')}
              {...debtCarOutstandingAmountFieldOption}
            />
          )}
        </Grid>
      </div>
    </>
  );
};
